import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import SiteFooter from "../../general/components/layout/SiteFooter";
import useRevealOnScroll from "../../general/components/common/useRevealOnScroll";
import { routes } from "../../general/routes/newsApi";
import FispTvNavbar from "../components/FispTvNavbar";
import { buildCategoryPath, fetchSectionLatestImages, fispTvSectionSegments } from "../data/noticias";

const segmentEyebrows = {
    "desde-adentro": { text: "ENTREVISTAS EN PROFUNDIDAD", color: "#d73f2f" },
    "segunda-opinion": { text: "ENTREVISTAS PROFESIONALES", color: "#b2a700" },
    "medicina-5": { text: "TECNOLOGÍA E INNOVACIÓN", color: "#0a7e8c" },
    "el-nudo": { text: "PODCAST - SPOTIFY", color: "#80623c" },
    "inspirando-el-cambio": { text: "LÍDERES DE LA SALUD", color: "#303754" },
    opinion: { text: "INFORMES Y DATOS", color: "#4b5639" },
    recetas: { text: "ANÁLISIS CULTURAL Y SALUD", color: "#0a7e8c" },
    "real-food": { text: "GASTRONOMÍA SALUDABLE", color: "#fd6e24" },
    "vida-sana": { text: "VLOGS DE BIENESTAR", color: "#43a5ee" },
};

function SegmentosState({ title, description }) {
    return (
        <section className="tv-directory-shell">
            <div className="tv-state-card">
                <h2>{title}</h2>
                <p>{description}</p>
            </div>
        </section>
    );
}

export default function Segmentos() {
    const pageRef = useRef(null);
    const [server, setServer] = useState(routes.Vercel);
    const [segments, setSegments] = useState(fispTvSectionSegments.map((segment) => ({ segment, image: "" })));
    const [status, setStatus] = useState("loading");

    useRevealOnScroll(pageRef);

    useEffect(() => {
        let active = true;

        fetch(`${routes.Hostinger}/ping`)
            .then(async (response) => {
                const data = await response.text();

                if (!active) {
                    return;
                }

                if (data === "pong") {
                    setServer(routes.Hostinger);
                } else {
                    setServer(routes.Vercel);
                }
            })
            .catch(() => {
                if (active) {
                    setServer(routes.Vercel);
                }
            });

        return () => {
            active = false;
        };
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        let active = true;

        async function loadSegments() {
            setStatus("loading");

            try {
                const result = await fetchSectionLatestImages(fispTvSectionSegments, controller.signal, server);

                if (!active) {
                    return;
                }

                setSegments(result);
                setStatus("ready");
            } catch (error) {
                if (error.name !== "AbortError") {
                    if (active) {
                        setStatus("error");
                    }
                }
            }
        }

        loadSegments();

        return () => {
            active = false;
            controller.abort();
        };
    }, [server]);

    return (
        <div className="fisp-tv tv-directory-page" ref={pageRef}>
            <FispTvNavbar activeCategory="" />

            {status === "error" ? (
                <SegmentosState title="No se pudieron cargar los segmentos" description="Hubo un problema consultando las secciones de FISP TV." />
            ) : null}

            {status !== "error" ? (
                <section className="tv-directory-shell">
                    <div className="tv-directory-hero reveal">
                        <div className="tv-directory-breadcrumb">
                            <Link to="/">Inicio</Link>
                            <span>/</span>
                            <Link to="/fisp-tv">FISP TV</Link>
                            <span>/</span>
                            <span>Segmentos</span>
                        </div>
                        <h1>Segmentos</h1>
                        <p>Explora las secciones editoriales de FISP TV y accede rapidamente a entrevistas, analisis, tendencias y contenidos tematicos organizados por enfoque.</p>
                    </div>

                    <div className="tv-directory-menu">
                        {segments.map(({ segment, image }, index) => {
                            return (
                                <Link
                                    key={segment.slug}
                                    to={buildCategoryPath(segment)}
                                    className="tv-directory-menu-item"
                                    style={{ "--segment-accent": segment.accentColor || "#0a7e8c" }}
                                >
                                    <div className="tv-directory-menu-media">
                                        {image ? <img src={image} alt={segment.label} /> : <div className={`ph bg${(index % 10) + 1}`}></div>}
                                    </div>

                                    <div className="tv-directory-menu-copy">
                                        <span
                                            className="tv-directory-kicker"
                                            style={{ color: segmentEyebrows[segment.slug]?.color || segment.accentColor || "#0a7e8c" }}
                                        >
                                            {segmentEyebrows[segment.slug]?.text}
                                        </span>
                                        <h2>{segment.label}</h2>
                                        <p>{segment.description}</p>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </section>
            ) : null}

            <SiteFooter variant="tv" description="Multimedio de salud digital con entrevistas, informes, podcasts y coberturas especiales." />
        </div>
    );
}
